import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import styled from '@emotion/styled';
import dayjs from 'dayjs';

const Container = styled(Box)`
  padding: 24px;
`;

const Title = styled(Typography)`
  font-size: 20px;
  font-weight: 700;
  color: #d32f2f;
  margin-bottom: 16px;
`;

const WarningText = styled(Typography)`
  font-size: 16px;
  color: #455a64;
  margin-bottom: 24px;
`;

const ConflictList = styled(Box)`
  background-color: #ffebee;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  max-height: 300px;
  overflow-y: auto;
`;

const ConflictItem = styled(Box)`
  padding: 8px 0;
  border-bottom: 1px solid #ffcdd2;
  &:last-child {
    border-bottom: none;
  }
`;

const ButtonRow = styled(Box)`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;

interface Conflict {
  worker_name: string;
  worker_id: number;
  conflicting_shift_id: number;
  conflicting_shift_title: string;
  conflicting_start: string;
  conflicting_end: string;
}

interface ValidationConflictsProps {
  conflicts: Conflict[];
  onCancel: () => void;
  onProceed: () => void;
}

const ValidationConflicts: React.FC<ValidationConflictsProps> = ({
  conflicts,
  onCancel,
  onProceed,
}) => {
  return (
    <Container>
      <Title>Schedule Conflict Detected</Title>
      <WarningText>
        Extending this shift is not possible because it will cause scheduling conflicts for the following workers:
      </WarningText>

      <ConflictList>
        {conflicts.map((conflict, index) => (
          <ConflictItem key={index}>
            <Typography variant="subtitle2" fontWeight="bold">
              {conflict.worker_name}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Conflict with: {conflict.conflicting_shift_title || 'Untitled Shift'}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              {dayjs(conflict.conflicting_start).format('DD MMM HH:mm')} - {dayjs(conflict.conflicting_end).format('HH:mm')}
            </Typography>
          </ConflictItem>
        ))}
      </ConflictList>

      <ButtonRow>
        <Button variant="contained" onClick={onCancel} color="primary">
          Close
        </Button>
      </ButtonRow>
    </Container>
  );
};

export default ValidationConflicts;
